module.exports = __webpack_public_path__ + "img/morningstar-logo.3842c45f.jpeg";